import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface LayoutProps {
	children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div
			className={`relative w-full min-h-[calc(100vh-64px)] md:min-h-[calc(100vh-144px)] pb-[48px]`}
		>
			{children}
		</div>
	);
};

export default Layout;
